// extracted by mini-css-extract-plugin
export default {"videosContainer":"videoClip_videosContainer__P8kmn"};